import React, { useState, useEffect, useRef } from 'react';
import './Header.css';

const Header = () => {
  const [logoAvailable, setLogoAvailable] = useState(true);
  const [isScrolled, setIsScrolled] = useState(false);
  const lastScrollY = useRef(0);
  const [isMobile, setIsMobile] = useState(false);
  const ticking = useRef(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (!ticking.current) {
        window.requestAnimationFrame(() => {
          const currentScrollY = window.scrollY;
          
          if (isMobile) {
            // Hide header when scrolling down, show when scrolling up
            if (currentScrollY > lastScrollY.current && currentScrollY > 100) {
              setIsScrolled(true);
            } else {
              setIsScrolled(false);
            }
          } else {
            // On desktop/iPad, minimize header when scrolled
            // Use hysteresis to prevent rapid bouncing: scroll down at 50px, scroll up at 30px
            if (currentScrollY > 50) {
              setIsScrolled(true);
            } else if (currentScrollY < 30) {
              setIsScrolled(false);
            }
            // Between 30-50px, keep the current state to prevent bouncing
          }
          
          lastScrollY.current = currentScrollY;
          ticking.current = false;
        });
        
        ticking.current = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isMobile]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const headerClass = isMobile 
    ? `header ${isScrolled ? 'header-hidden' : ''}`
    : `header ${isScrolled ? 'header-scrolled' : ''}`;

  return (
    <header className={headerClass}>
      <div className="header-content">
        <div className="company-branding" onClick={scrollToTop} style={{ cursor: 'pointer' }}>
          <div className="logo-container">
            {logoAvailable ? (
              <img
                src="/MCMovers Logo/logo.png"
                alt="MC Movers Logo"
                className="company-logo"
                onError={() => setLogoAvailable(false)}
              />
            ) : (
              <div className="logo-placeholder">
                <div className="logo-shield">
                  <div className="logo-mc">MC</div>
                  <div className="logo-movers">MOVERS</div>
                  <div className="logo-truck">🚛</div>
                  <div className="logo-tagline">My Community Movers</div>
                </div>
              </div>
            )}
          </div>
          <div className="company-text">
            <h1 className="company-name">MC Movers</h1>
            <p className="company-tagline">My Community Movers</p>
          </div>
        </div>
        <div className="contact-info">
          <a className="phone" href="tel:+18008072173">(800) 807-2173</a>
        </div>
      </div>
    </header>
  );
};

export default Header;
